<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: ['mostrar', 'id', 'salvando'],
    computed: {
      show() {
        return this.mostrar;
      }
    }
  }
</script>

<template>
  <div>
    <modal 
        ref="modal"
        :value="show" 
        effect="fade" 
        @closed="$emit('fechado')"
        :backdrop="!salvando">
      <div slot="modal-header" class="modal-header hide"></div>

      <div class="swal2-icon swal2-question" style="display: block;">?</div>

      <h3 class="text-center">
        Deseja liberar esta compra?
      </h3>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" :disabled="salvando" @click="$emit('liberar')">
          <i class="fa fa-check"></i> Liberar
        </button>
        <button type="button" class="btn btn-default" @click="$refs.modal.action(false, 3)" :disabled="salvando">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalLiberarCompra.vue